import * as Mod1 from "./app/helpers/animated-bound-avatar";
import * as Mod2 from "./app/lib/animated-avatar-utils";
import * as Mod3 from "./discourse/connectors/user-profile-avatar-img-wrapper/user-profile-avatar-img-wrapper.gjs";
import * as Mod4 from "./initializers/animated-avatars";
const compatModules = {
  "app/helpers/animated-bound-avatar": Mod1,
  "app/lib/animated-avatar-utils": Mod2,
  "discourse/connectors/user-profile-avatar-img-wrapper/user-profile-avatar-img-wrapper": Mod3,
  "initializers/animated-avatars": Mod4,
};
export { compatModules };
export default compatModules;
